require('./angular-sanitize');
module.exports = 'ngSanitize';



//////////////////
// WEBPACK FOOTER
// ../node_modules/angular-sanitize/index.js
// module id = 534
// module chunks = 3